import React from 'react';
import {HashRouter, Redirect, Route, Switch} from 'react-router-dom';

import withLayout from '../modules/ui/components/Layout';
import {allFlattenRoutes as routes} from './index';
import ErrorPage from '../modules/ui/layouts/ErrorPage';
import NoPermissionPage from '../modules/ui/layouts/NoPermissionPage';

const Routes = (props) => {
    return (
        // rendering the router with layout
        <HashRouter>
            <Switch>
                <Redirect exact from="/" to={'/dashboard'}/>
                {routes.map((route, index) => {
                    const ignoreRoute = (route.children !== undefined && route.children.every(subRoute => subRoute.show)) || !route.component;
                    return (
                        !ignoreRoute && (
                            <route.route
                                key={index}
                                path={route.path}
                                roles={route.roles}
                                exact={route.exact}
                                component={withLayout(props => {
                                    return <route.component {...props} />;
                                })}
                                permissions={route.permissions}
                            />
                        )
                    );
                })}
                <Route path="/contact-admin">
                    <NoPermissionPage exact email='support@akadoc.ai'/>
                </Route>
                <Route path="*">
                    <ErrorPage title='404' message='The page you are trying to find does not exist.'
                               detail=''
                               refreshButton={true}
                               classNames='mt-5'
                    />
                </Route>
            </Switch>
        </HashRouter>
    );
}

export default Routes;
